import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
//
import App from './App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// routes

// theme
import ThemeProvider from './theme';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
import { AuthProvider } from './context/authContext';
import { ModalProvider } from './context/modalContext';
import { ThemeSettingsProvider } from './context/themeSettingsContext';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <ModalProvider>
      <AuthProvider>
        <ThemeSettingsProvider>
          <HelmetProvider>
            <ThemeProvider>
              <ScrollToTop />
              <StyledChart />
              <App />
            </ThemeProvider>
          </HelmetProvider>
        </ThemeSettingsProvider>
      </AuthProvider>
    </ModalProvider>
  </BrowserRouter>
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
